import { logger as log } from '@common/logger';
import { vappContainer } from '@/application';
import { SignInPageService } from '@/pages/SignIn';
import { StorageModule } from '@vlinder-web/storage-module-react';

import toast from 'react-hot-toast';
import { AppNavigatorService } from '@/AppNavigator';
const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const validatePassword = async (context: any, event: any) => {
  const method = 'signIn';
  const storageSrv = StorageModule.getInstance();

  try {
    log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
    const srv = getSrv();
    const content = await srv.validatePassword(event?.payload);
    console.log(`signInUser service content:`, content);

    if (content?.accessToken || content?.signInToken) {
      const passwordRecentlyUpdated = content?.passwordRecentlyUpdated;
      srv.setUserEmail(event?.payload?.email);

      if (content?.emailVerified) {
        // Store user profile in local or session
        const storageType = event?.payload?.rememberMe ? 'local' : 'session';
        storageSrv.set(
          'userProfile',
          {
            ...content,
            orgRole: content?.orgRoles[0]?.org?.orgRole,
            signInToken: content?.signInToken,
            accessToken: content?.accessToken,
          },
          storageType
        );
      }

      return {
        type: content?.emailVerified ? 'EMAIL_VERIFIED' : 'EMAIL_NOT_VERIFIED',
        PASSWORD_RECENTLY_UPDATED: passwordRecentlyUpdated,
        value: content,
      };
    } else {
      const msg = content?.error || 'Invalid credentials';
      toast.error(msg);
      return Promise.reject({ type: 'ERROR', value: content });
    }
  } catch (err: any) {
    console.log(err);
    const _msg = err;
    log.error(MODULE_NAME, `error in ${method}, msg: ${_msg}`);
    toast.error(_msg);

    // ❌ reject with type ERROR
    return Promise.reject({ type: 'ERROR', value: _msg });
  }
};
